// @flow

import { type PrsSupport } from '@tectonics/prs/support';
import { type Feature } from '@tectonics/prs/feature';

export function getAllFeatures(prsSupport: PrsSupport): ImmutableArray<Feature> {
  return prsSupport.features;
}
